import { Component } from '@angular/core';

@Component({
    selector: 'changelog-list',
    templateUrl: './changelog-list.component.html',
    styleUrls: ['./changelog-list.component.scss'],
})
export class ChangelogListComponent {}
